import { inject } from 'vue'
import { Styles } from './types/Styles'

export function getStyles (): Styles {
  const styles = inject<Styles>('vue-service:styles')

  if (!styles) {
    throw new Error('could not find the styles. Ensure it is created when the app is bootstrapped')
  }

  return styles
}
